import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { HRMAccountTeamDTO, ProjectDTO, ProjectRequestDTO, SelectionOptions } from '@/models';
import { buildProjectRequestData, buildProjectTypeOptions, fetchAllActivities } from '@/services';
import { ProjectValidationError } from '@/components/pages/project-evaluation/project-information/project-information-mixin';

@Component
export default class ProjectInformationForm extends Vue {
  @Prop() projectData: ProjectRequestDTO;
  @Prop() projectValidationError: ProjectValidationError;
  @Prop({ default: false }) isOldProject: boolean;
  @Prop({ default: [] }) userOptions: SelectionOptions;

  private activityOptions = [] as string[];
  private hrmProjectOptions = [] as HRMAccountTeamDTO[];
  private selectedHrmProject = {} as HRMAccountTeamDTO;
  private startDateMenu = false;
  private endDateMenu = false;

  private readonly typeOptions: SelectionOptions = buildProjectTypeOptions();

  get projectInfo(): ProjectDTO {
    return this.$store.getters['project/project'];
  }

  @Watch('projectInfo')
  async syncHrmProjectData(): Promise<void> {
    const projectRequest = await buildProjectRequestData(this.projectInfo);
    this.projectData.hrmProjectId = projectRequest.hrmProjectId;
    this.projectData.clientId = projectRequest.clientId;
    this.projectData.activities = projectRequest.activities || [];
    const currentHrmProject =
      this.hrmProjectOptions.find(project => project.projectId === this.projectData.hrmProjectId) ||
      ({} as HRMAccountTeamDTO);
    await this.onSelectProjectChanged(currentHrmProject, true);
  }

  async onSelectProjectChanged(project: HRMAccountTeamDTO, keepSelectedActivities = false): Promise<void> {
    this.selectedHrmProject = project || ({} as HRMAccountTeamDTO);
    if (!project?.projectId) {
      this.activityOptions = [];
      this.projectData.activities = [];
      this.projectData.hrmProjectId = undefined;
      this.projectData.hrmProjectName = undefined;
      this.projectData.clientId = undefined;
      return;
    }

    const selectedActivities = keepSelectedActivities ? this.projectData.activities || [] : [];
    this.projectData.activities = selectedActivities;
    this.activityOptions = selectedActivities;
    this.projectData.hrmProjectId = project.projectId;
    this.projectData.hrmProjectName = this.buildHrmProjectName(project);
    this.projectData.clientId = project.clientId;

    const { data } = await fetchAllActivities();
    this.activityOptions = data
      .filter(activity => activity.projectId === project.projectId)
      .map(activity => activity.name);
  }

  private buildHrmProjectName(project: HRMAccountTeamDTO): string {
    return `${project.clientName} - ${project.projectName}`;
  }

  async created(): Promise<void> {
    this.hrmProjectOptions =
      this.$store.getters['project/hrmProjects']?.length > 0
        ? this.$store.getters['project/hrmProjects']
        : await this.$store.dispatch('project/fetchHRMProjects');
    await this.syncHrmProjectData();
  }
}
